if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');
        this.addonTotals = window.__productAddonTotals || { price: 0, compareAtPrice: 0, items: [] };

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');
        this.currentVariant = this.variantData.find(
          (variant) => Number(variant.id) === Number(this.variantIdSelect?.value)
        );

        this.init();
        document.addEventListener('product:addons-change', (event) => {
          this.setAddonTotals(event.detail);
        });
        document.addEventListener('dual-product:variant-change', (event) => {
          this.applyDualProductSelection(event.detail);
        });
        document.addEventListener('dual-product:initial-price', (event) => {
          this.applyDualProductInitialPrice(event.detail);
        });

        if (window.__dualProductSelection) {
          this.applyDualProductSelection(window.__dualProductSelection);
        } else if (window.__dualProductInitialPrice) {
          this.applyDualProductInitialPrice(window.__dualProductInitialPrice);
        }

        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        // Track if any hidden-sticky-atc-bar element is fully visible
        this.isHiddenByCustomElements = false;

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Only apply the original logic if not hidden by custom elements
              if (!this.isHiddenByCustomElements) {
                this.container.classList.toggle('sticky-atc-bar--show', !entry.isIntersecting);
              }
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);

        // Observe all hidden-sticky-atc-bar elements
        this.initHiddenStickyBarObserver();

        this.syncWithMainProductForm();
      }

      initHiddenStickyBarObserver() {
        const hiddenElements = document.querySelectorAll('.hidden-sticky-atc-bar');
        if (hiddenElements.length === 0) return;

        // Track which elements are fully visible
        this.visibleHiddenElements = new Set();

        this.hiddenElementsObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                // Element is fully visible
                this.visibleHiddenElements.add(entry.target);
              } else {
                // Element is not fully visible
                this.visibleHiddenElements.delete(entry.target);
              }
            });

            // Update the hidden state
            const shouldHide = this.visibleHiddenElements.size > 0;
            this.isHiddenByCustomElements = shouldHide;

            // If any hidden-sticky-atc-bar element is fully visible, hide the sticky bar
            if (shouldHide) {
              this.container.classList.remove('sticky-atc-bar--show');
            } else {
              // Re-check the original condition if no hidden elements are visible
              if (this.productFormActions) {
                const rect = this.productFormActions.getBoundingClientRect();
                const isIntersecting = rect.top < window.innerHeight && rect.bottom > 0;
                this.container.classList.toggle('sticky-atc-bar--show', !isIntersecting);
              }
            }
          },
          { threshold: [0, 1] }
        );

        hiddenElements.forEach((element) => {
          this.hiddenElementsObserver.observe(element);
        });
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        if (!priceWrapper) return;
        const unitPrice = unitPriceWrapper?.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
        const addonPrice = Number(this.addonTotals?.price || 0);
        const addonCompareAtPrice = Number(this.addonTotals?.compareAtPrice || addonPrice);
        const baseCompareAtPrice = compare_at_price && compare_at_price > price ? compare_at_price : price;
        const displayPrice = Number(price || 0) + addonPrice;
        const displayCompareAtPrice = Number(baseCompareAtPrice || 0) + addonCompareAtPrice;

        // On sale.
        if (displayCompareAtPrice > displayPrice) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && displayCompareAtPrice > displayPrice) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(displayCompareAtPrice, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice?.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice && addonPrice === 0) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper?.classList.add('hidden');
        }
      }

      setAddonTotals(detail) {
        this.addonTotals = detail || { price: 0, compareAtPrice: 0, items: [] };

        if (!this.currentVariant && window.__dualProductSelection?.variant) {
          this.currentVariant = window.__dualProductSelection.variant;
        }

        if (this.currentVariant) this.updatePrice();
      }

      applyDualProductSelection(detail) {
        if (!detail?.variant) return;
        if (detail.sectionId && this.mainProductInfo?.dataset.section !== String(detail.sectionId)) return;

        this.currentVariant = detail.variant;
        this.dataset.productId = detail.product?.id || this.dataset.productId;

        const variantInput = this.querySelector('[name="id"]');
        if (variantInput) {
          if (
            variantInput.tagName === 'SELECT' &&
            !Array.from(variantInput.options).some((option) => Number(option.value) === Number(detail.variant.id))
          ) {
            variantInput.add(new Option(detail.variant.title, detail.variant.id, true, true));
          }
          variantInput.value = detail.variant.id;
        }

        const title = this.querySelector('.sticky-atc-bar__product-title');
        if (title) title.textContent = detail.displayTitle || detail.product?.title || '';

        const image = this.querySelector('.sticky-atc-bar__product-image img');
        if (image && detail.displayImage) {
          image.src = detail.displayImage;
          image.srcset = detail.displayImage;
        }

        this.updatePrice();
        this.updateButton(!detail.variant.available, FoxTheme.variantStrings.soldOut);
      }

      applyDualProductInitialPrice(detail) {
        if (!detail?.variant) return;
        if (detail.sectionId && this.mainProductInfo?.dataset.section !== String(detail.sectionId)) return;

        this.currentVariant = detail.variant;
        this.updatePrice();
        this.updateButton(true, '', false);
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
